export const baseUrl = `https://warehouse.theteamkw.com/`;
// export const baseUrl = `http://127.0.0.1:8000/`;

export const domainUrl = `https://wh.theteamkw.com/`;
export const defaultImageUrl =
  'https://theteamwarehouse.nyc3.digitaloceanspaces.com/WareHouse/WareHouse/user.png';
export const defaultCourseUrl =
  'https://theteamwarehouse.nyc3.digitaloceanspaces.com/WareHouse/WareHouse/download.jpeg';
